import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How I discovered one of the greatest influences on my life",
  "description": "",
  "published": "2009-12-15T00:00:00.000Z",
  "redirect_from": ["/blog/how-i-discovered-one-of-the-greatest-influences-on-my-life/swizec/982"],
  "categories": "Arts, Fear and Loathing in Las Vegas, food for thought, Hunter Thompson, life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Fear_and_Loathing_in_Las_Vegas.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/300px-Fear_and_Loathing_in_Las_Vegas.jpg",
              "alt": "Fear and Loathing in Las Vegas."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Fear_and_Loathing_in_Las_Vegas.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Last night I was discussing `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Gothic_rock",
        "title": "Gothic rock"
      }}>{`goth music`}</a>{` with a mate and somehow the debate turned into my showing him around what goth music was in the first place. Blahblahblah.`}</p>
    <p>{`This eventually led to my showing him Velvet Acid Christ, which I still don't know whether they're goth or industrial. And then I showed him a certain song. It triggered memories, many memories.`}</p>
    <p>{`Particularly the whole story of how I discovered `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Fear_and_Loathing_in_Las_Vegas",
        "title": "Fear and Loathing in Las Vegas"
      }}>{`Fear and Loathing in Las Vegas`}</a>{` and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Hunter_S._Thompson",
        "title": "Hunter S. Thompson"
      }}>{`Hunter Thompson`}</a>{` in general - two of the biggest influences on my life and my art and pretty much everything I've ever done since reading the book, watching the movie and becoming a raging fan.`}</p>
    <p>{`It all started out when I was a wee lad of 15-ish and listening to an internet radio - its name eludes my memory - that played a certain song a whole lot. It contained clips like `}<em parentName="p">{`Oh god, did you eat all this acid? That's right, you see!`}</em>{` and uhm ... `}<em parentName="p">{`This is not a good town for psychadelic drugs, extremely menacing vibrations were all around us.`}</em></p>
    <p>{`Back then I was quite a regular and chatted a lot with the DJ's, yes it was a fucking awesome radio, and eventually this meant I asked what the song was and whether it was any particular mix they themselves created.`}</p>
    <p>{`This is how I discovered Velvet Acid Christ.`}</p>
    <p>{`So I listened to their music some more and god knows when, I finally decided to look up these sound clips and figure out where they were from.`}</p>
    <p>{`This is how I discovered Fear and Loathing in Las Vegas the movie.`}</p>
    <p>{`Watching the movie had an instant effect of making a raging drug lover out of me. Unfortunately, I haven't managed to get my greedy little paws on most of the stuff I've wanted to try ... have been hunting passively for acid for gawd knows how many years now ... but I did try ether that I've made myself. The effects truly are just like the movie describes, it's bloody fun too!`}</p>
    <p>{`Anyhow, eventually I decided to read Fear and Loathing in Las Vegas the book.`}</p>
    <p>{`Fucking brilliant stuff! My writing style has never been the same again and it only cemented my dire desire to get into psychadelic drugs as soon as I possibly can ... I still haven't. For shame.`}</p>
    <p>{`The fucking suck part of wanting to do psychadelic drugs is that we're not in the 60's anymore and everybody just wants to get stoned and drunk and dance for a little longer than usual. Bleh. I want to have `}{`_`}{`fun! `}{`_`}{`But this is really another story, which says more about my lack of connections to the drug world than anything else.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/e3980dd6-72e8-4553-a085-5ee0f56a6451/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=e3980dd6-72e8-4553-a085-5ee0f56a6451",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      